import { useState, useEffect, useCallback } from "react";
import {
  ActiveOpportunityContext,
  getActiveOpportunity,
  setActiveOpportunity as setServiceActiveOpportunity,
  clearActiveOpportunity as clearServiceActiveOpportunity,
  subscribeToActiveOpportunity,
} from "../services/activeOpportunityService";

export interface UseActiveOpportunityResult {
  activeOpp: ActiveOpportunityContext | null;
  setActiveOpp: (opp: {
    id: string;
    title: string;
    client: string;
    stage: ActiveOpportunityContext["stage"];
  }) => void;
  clearActiveOpp: (targetId?: string) => void;
}

export function useActiveOpportunity(): UseActiveOpportunityResult {
  const [activeOpp, setActiveOppState] = useState<ActiveOpportunityContext | null>(() =>
    getActiveOpportunity(),
  );

  useEffect(() => {
    const unsubscribe = subscribeToActiveOpportunity((opp) => {
      setActiveOppState(opp);
    });
    return unsubscribe;
  }, []);

  const setActiveOpp = useCallback(
    (opp: {
      id: string;
      title: string;
      client: string;
      stage: ActiveOpportunityContext["stage"];
    }) => {
      setServiceActiveOpportunity(opp);
    },
    [],
  );

  const clearActiveOpp = useCallback((targetId?: string) => {
    clearServiceActiveOpportunity(targetId);
  }, []);

  return { activeOpp, setActiveOpp, clearActiveOpp };
}
